// extracted by mini-css-extract-plugin
export var label = "_dk-2";
export var slideContainer = "_dk-0";
export var slider = "_dk-1";